import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { IMAGES } from '../utils/constants';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offerta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-blue-700 pt-16 pb-20 px-4 overflow-hidden" data-id="element-118">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-119">
        <div className="absolute -top-[30%] -right-[10%] w-[70%] h-[70%] rounded-full bg-blue-600/50 blur-3xl" data-id="element-120"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-blue-800/50 blur-3xl" data-id="element-121"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-122">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-yellow-400/20 border border-yellow-400/50 mb-6" data-id="element-123">
          <StarIcon className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-124" />
          <span className="text-yellow-100 text-sm font-bold uppercase tracking-wider" data-id="element-125">
            Il Sistema #1 per Insegnanti
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6 tracking-tight drop-shadow-lg" data-id="element-126">
          Mega-Pack <span className="text-yellow-400" data-id="element-127">Educazione Fisica</span>
        </h1>

        <p className="text-lg md:text-2xl text-blue-100 mb-10 max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-128">
          Il sistema completo che ti permette di preparare lezioni coinvolgenti
          in pochi minuti.
        </p>

        {/* Pack Composite Image */}
        <div className="relative max-w-3xl mx-auto mb-12 flex justify-center items-end h-64 md:h-80 lg:h-96" data-id="element-129">
          <img src={IMAGES.tomo5} alt="Tomo 5" className="absolute w-1/4 transform -rotate-12 -translate-x-32 md:-translate-x-48 z-10 shadow-2xl rounded-lg" data-id="element-130" />
          <img src={IMAGES.tomo3} alt="Tomo 3" className="absolute w-1/4 transform -rotate-6 -translate-x-16 md:-translate-x-24 z-20 shadow-2xl rounded-lg" data-id="element-131" />
          <img src={IMAGES.tomo1} alt="Tomo 1" className="absolute w-1/3 z-30 shadow-2xl rounded-lg transform scale-110" data-id="element-132" />
          <img src={IMAGES.tomo2} alt="Tomo 2" className="absolute w-1/4 transform rotate-6 translate-x-16 md:translate-x-24 z-20 shadow-2xl rounded-lg" data-id="element-133" />
          <img src={IMAGES.tomo4} alt="Tomo 4" className="absolute w-1/4 transform rotate-12 translate-x-32 md:translate-x-48 z-10 shadow-2xl rounded-lg" data-id="element-134" />
        </div>

        <div className="flex flex-col items-center justify-center gap-4" data-id="element-135">
          <button onClick={scrollToOffer} className="inline-block w-full sm:w-auto bg-green-500 hover:bg-green-400 text-white font-extrabold text-xl md:text-2xl py-5 px-12 rounded-full shadow-[0_8px_30px_rgb(34,197,94,0.4)] transform hover:-translate-y-1 transition-all duration-300 animate-pulse-fast text-center border-b-4 border-green-700" data-id="element-136">
            SÌ, VOGLIO IL MEGA-PACK
          </button>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 mt-4 text-blue-100 text-sm font-medium" data-id="element-137">
            <div className="flex items-center gap-1.5" data-id="element-138">
              <ShieldCheckIcon className="w-5 h-5 text-green-400" data-id="element-139" />
              <span data-id="element-140">Garanzia 7 Giorni</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-141">
              <div className="flex text-yellow-400" data-id="element-142">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-143" />)}
              </div>
              <span data-id="element-144">4.9/5 (2.500+ recensioni)</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}